import { NextPage }     from 'next';
import AppHead          from '@core/components/common/AppHead';
import AppLayout        from '@layouts/AppLayout';
import { TermsLanding } from '@features/static-pages/TermsLanding';


const TermsPage: NextPage = () => {
    return (
        <TermsLanding/>
    );
};

// @ts-expect-error
TermsPage.getLayout = function getLayout(page: typeof TermsPage) {
    return (
        <>
            <AppHead
                title="Terms & Conditions"
                description="If you would like to know more about the use of the DXB Stay website and the terms and conditions of using and/or booking and/or staying at the properties we offer please read through this page."
            />

            <AppLayout requireAuth={false}>
                {/*// @ts-expect-error*/}
                {page}
            </AppLayout>
        </>
    );
};

export default TermsPage;
